/**
 * Created by slava on 02.08.17.
 */

const LoseWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.level = Game.currentGame.level;

        const styles = cleverapps.styles.LoseWindow;

        const noLifeRefill = cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_DISABLED && cleverapps.lives && cleverapps.lives.isEmpty();
        const canTryAgain = !cleverapps.isKnockoutGame() && !noLifeRefill;

        const buttons = [];
        if (canTryAgain) {
            buttons.push(this.createTryAgainButton());
        }

        this._super({
            name: "losewindow",
            content: this.createContent(),
            title: this.getTitleText(),
            noBackground: styles.noBackground,
            openSound: bundles.lose_window.urls.lose_effect,
            buttons,
            closeButton: buttons.length === 0
        });

        this.homeButton = this.createHomeButton();
        this.addChild(this.homeButton);

        if (cleverapps.lives) {
            cleverapps.lives.on("changeAmount", this.createListener(this.updateWindow.bind(this)), this);
            cleverapps.lives.on("buyUnlimitedLives", this.createListener(this.updateWindow.bind(this)), this);
        }

        if (styles.hardLevel && this.level.isHard()) {
            const hardLevelIcon = new HardLevelWindowIcon();
            hardLevelIcon.setAlignment(styles.hardLevel);
            hardLevelIcon.pulseAnimation();
            this.window.addChild(hardLevelIcon);
        }
    },

    createHomeButton: function () {
        const homeButton = new cleverapps.UI.Button({
            type: {
                button_png: bundles.controlbuttons.frames.back_button_png,
                button_on_png: bundles.controlbuttons.frames.back_button_on_png,
                SKIP_RESOLUTION: {
                    padding: {
                        left: 0.05,
                        right: 0.05,
                        top: 0.05,
                        bottom: 0.05
                    }
                }
            },
            onClicked: function () {
                const boatswain = Game.currentGame && Game.currentGame.boatswain;
                if (boatswain) {
                    boatswain.setIntent(Boatswain.RETURN_INTENT);
                }

                this.close();
            }.bind(this),
            content: new cc.Sprite(bundles.controlbuttons.frames.home_icon)
        });
        homeButton.avoidNode = "HomeButton";
        homeButton.onResize = function () {
            homeButton.setAlignment(this.styles.HomeButton.position);
        }.bind(this);
        homeButton.onResize();
        return homeButton;
    },

    getTitleText: function () {
        if (Game.currentGame.getMode() === GameBase.MODE_HIGHSCORE) {
            return false;
        }

        return {
            text: Messages.get("LoseWindow.title"),
            font: cleverapps.styles.FONTS.LOSE_WINDOW_TITLE_TEXT
        };
    },

    createTryAgainButton: function () {
        const styles = cleverapps.styles.LoseWindow;

        return new cleverapps.UI.Button({
            text: Messages.get("TryAgain"),
            width: styles.button.width,
            height: styles.button.height,
            onClicked: () => {
                if (Level.IsEnoughLives(this.level)) {
                    Game.currentGame.boatswain.setIntent(Boatswain.REPLAY_INTENT);

                    this.close();
                } else {
                    cleverapps.focusManager.display({
                        focus: "ReplayNoLives",
                        stack: true,
                        action: (f) => {
                            if (cleverapps.unlimitedLives && cleverapps.unlimitedLives.freeOfferIsAvailable()) {
                                cleverapps.unlimitedLives.showFreeOffer(f);
                            } else {
                                Level.OpenLivesShop();
                                cleverapps.focusManager.onceNoWindowsListener = f;
                            }
                        }
                    });
                }
            }
        });
    },

    onShow: function () {
        let delay = 0;

        this.content.children.forEach((component) => {
            if (component.showUp) {
                delay += component.showUp();
            }
        });

        if (cleverapps.config.features.includes("lantern_start") && typeof Lantern !== "undefined" && Lantern.GetPreviousStreak(this.level) > 0) {
            this.runLanternAnimation();
        }

        this._super(delay / 1000 + 0.5);
    },

    runLanternAnimation: function () {
        const styles = cleverapps.styles.LoseWindow.lantern;

        const lanternAnimation = new cc.Node();
        lanternAnimation.setVisible(false);
        lanternAnimation.setScale(cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? 0.8 : 1);
        cleverapps.Scenes.GetMovingNode().addChild(lanternAnimation);

        const bg = cleverapps.UI.createScale9Sprite(cleverapps.skins.getSlot("sidebarBg") || bundles.sidebar.frames.icon_bg);
        lanternAnimation.addChild(bg);
        bg.setAlignment(bg.width / 2, bg.height / 2);
        lanternAnimation.setContentSize(bg.getContentSize());

        const icon = new cleverapps.Spine(bundles.lantern.jsons.lantern_reward_json);
        icon.setAnimation(0, `idle_${String(Lantern.GetPreviousStreak(this.level))}`, true);
        icon.setAlignment(bg.width / 2, bg.height / 2);
        bg.addChild(icon);

        lanternAnimation.setAlignment(cleverapps.resolution.getSceneSize().width - lanternAnimation.width - styles.padding, styles.y);

        lanternAnimation.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.Show(),
            new cc.DelayTime(1.4),
            new cc.MoveBy(0.5, styles.hideOffset, 0).easing(cc.easeInOut(1)),
            new cc.RemoveSelf()
        ));

        bg.runAction(new cc.Spawn(
            new cc.Sequence(
                new cc.MoveBy(0, styles.hideOffset, 0),
                new cc.DelayTime(0.2),
                new cc.MoveBy(0.5, -styles.hideOffset, 0).easing(cc.easeBackOut())
            ),
            new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.CallFunc(() => {
                    icon.setAnimationAndIdleAfter(`lose_${String(Lantern.GetPreviousStreak(this.level))}`, "idle_0");
                    cleverapps.effects.fire("mission.lantern.lose");
                })
            )
        ));
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "sad"
        };
    },

    createAnimationNode: function () {
        const styles = cleverapps.styles.LoseWindow;

        const animationNode = new cc.Node();
        animationNode.setAnchorPoint(0.5, 0.5);
        animationNode.setContentSize2(styles.animation);

        this.animation = new cleverapps.Spine(bundles.lose_window.jsons.lose_json);
        this.animation.setAnimation(0, "idle", true);
        this.animation.setAlignment(styles.animation);

        animationNode.addChild(this.animation);

        return animationNode;
    },

    createLivesLayout: function (silent) {
        const styles = cleverapps.styles.LoseWindow;

        const items = [];
        for (let i = 0; i < cleverapps.lives.getMaxLives(); i++) {
            let icon;
            
            if (i === cleverapps.lives.amount && !silent) {
                icon = new cleverapps.Spine(bundles.lose_window.jsons.level_failed_small_hearts_json);
                icon.setAnimation(0, "animation", false);
            } else {
                const heartSpriteName = i < cleverapps.lives.amount ? bundles.lose_window.frames.level_failed_heart_png : bundles.lose_window.frames.level_failed_heart_empty_png;

                icon = new cc.Sprite(heartSpriteName);
            }

            items.push(icon);
        }
        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.heartsMargin
        });
    },

    createLivesLeftBlock: function (silent) {
        const styles = cleverapps.styles.LoseWindow;

        const items = [];

        const textFont = cleverapps.styles.FONTS.LOSE_WINDOW_TEXT || cleverapps.styles.FONTS.WINDOW_TEXT;

        let text;
        if (cleverapps.unlimitedLives && cleverapps.unlimitedLives.checkBuyed()) {
            text = cleverapps.UI.generateOnlyText(Messages.get("LoseWindow.livesLeftUnlimited"), textFont);
            text.setDimensions(styles.livesLeftText.width, 0);
            text.fitTo(undefined, styles.livesLeftText.height);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            items.push(text);
        } else {
            text = cleverapps.UI.generateOnlyText(Messages.get("LoseWindow.livesLeft"), textFont);
            text.fitTo(styles.livesLeftText.width, styles.livesLeftText.height);
            items.push(text);

            const heartsNode = this.createLivesLayout(silent);
            items.push(heartsNode);
        }

        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.livesLeftMargin
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.LoseWindow;

        const items = this.createContentItems();

        if (this.animation) {
            const animationName = cleverapps.unlimitedLives && cleverapps.unlimitedLives.checkBuyed() ? "open_unlim" : "open";
            this.animation.setAnimationAndIdleAfter(animationName, "idle");
        }

        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.content.margin,
            padding: styles.content.padding
        });
    },

    createContentItems: function (silent) {
        const game = Game.currentGame;

        const items = [];

        if (game.useLives()) {
            const animationNode = this.createAnimationNode();
            items.push(animationNode);

            this.livesLeftBlock = this.createLivesLeftBlock(silent);
            items.push(this.livesLeftBlock);
        }

        if (game.getMode() === GameBase.MODE_HIGHSCORE) {
            items.push(new ScoreComponent());
        }

        return items;
    },

    updateWindow: function () {
        const items = this.createContentItems(true);
        this.content.setItems(items, true);
    },

    listBundles: function () {
        return ["lose_window"];
    }
});

cleverapps.styles.LoseWindow = {
    heartsMargin: 5,
    livesLeftMargin: 15,

    livesLeftText: {
        width: 800,
        height: 180
    },

    content: {
        margin: 40,

        padding: {
            x: 80,
            bottom: 50,
            top: 50
        }
    },

    animation: {
        width: 300,
        height: 300,

        x: { align: "center" },
        y: { align: "center" }
    },

    button: {
        width: 300,
        height: 100
    },

    lantern: {
        hideOffset: 500,
        y: 120,
        padding: 10
    }
};
